import type { ComponentProps } from 'react';

const CustomImage = (props: ComponentProps<'img'>) => {
  return <img {...props} />;
};

export default CustomImage;
